import { button2, critical, primary, success, surfaceLiquid01, surfaceLiquid02, warning } from '@salutejs/plasma-core';
import { css } from 'styled-components';
var statuses = {
  success: success,
  warning: warning,
  error: critical
};
export var applyB2CSelectButton = function applyB2CSelectButton(_ref) {
  var hasItems = _ref.hasItems,
      status = _ref.status;
  return css(["", ";--plasma-select-button-arrow-margin:0 -0.25rem 0 0.75rem;padding:1rem;background-color:", ";border:0 none;border-radius:0.75rem;color:", ";&:focus{outline:0 none;}", " &:focus:not(:disabled){background-color:", ";}", ""], button2, surfaceLiquid01, primary, hasItems && css(["&:hover:not(:disabled),&:focus:not(:disabled){background-color:", ";color:", ";cursor:pointer;}"], surfaceLiquid02, primary), surfaceLiquid02, status && css(["color:", ";"], statuses[status]));
};